"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (pendo, handleError) => ({
    initialize() {
        pendo.initialize();
    },
    /**
     * Tracks a custom event with enabled analytics services.
     *
     * @param event The event name to track
     * @param properties A key/value object containing additional tracking metadata
     */
    async track(event, properties = {}) {
        try {
            await Promise.all([
                (async () => {
                    pendo.track(event, properties);
                })(),
            ]);
        }
        catch (error) {
            if (handleError) {
                handleError(error);
            }
            else {
                throw error;
            }
        }
    },
    /**
     * Identifies a user with enabled analytics services and enables tracking for the user.
     *
     * @param userMetadata Metadata to identify the user with.
     * @param userMetadata.id A unique identifier for the user.
     * @param userMetadata.name The user's name.
     * @param userMetadata.email The user's email.
     */
    async identifyUser({ id, email, name }) {
        pendo.identify({
            visitor: {
                id,
                full_name: name,
                email,
            },
        });
    },
    /**
     * Adds additional metadata to the identified user.
     *
     * @param updateUserMetadata Additional properties to set on the identified user.
     * @param updateUserMetadata.clientName The currently selected client name.
     * @param updateUserMetadata.accountId The currently selected client's ID and line of business ID.
     */
    async updateUserMetadata({ clientName, accountId, }) {
        pendo.updateOptions({
            account: {
                id: `${clientName} (${accountId}) `,
            },
        });
    },
});
